import { CTA } from "./components/CTA";
import { FAQ } from "./components/FAQ";
import { Features } from "./components/Features";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { HowItWorks } from "./components/HowItWorks";
import { Team } from "./components/Team";

export default function App() {
	return (
		<div className="min-h-screen bg-background">
			<Header />
			<Hero />
			<HowItWorks />
			<Features />
			<Team />
			<CTA />
			<FAQ />
			<Footer />
		</div>
	);
}
